<script>
  import PkgDependencies from "./PkgDependencies.svelte"; 

  export let metadata;

  $: {
    let metadataFiller = metadata?.run?.type === 'code' ? {
      run: {
        type: 'code',
        base_image: {
          name: metadata?.run?.base_image ? metadata.run.base_image.name : 'python',
          pkg_dependencies: metadata?.run?.base_image?.pkg_dependencies || [],
        },
        run_timeout: metadata?.run?.run_timeout ? metadata.run.run_timeout : 86400,
        idle_timeout: metadata?.run?.idle_timeout ? metadata.run.idle_timeout : 60,
        cpus: metadata?.run?.cpus ? metadata.run.cpus : 0.05,
        memory: metadata?.run?.memory ? metadata.run.memory : 100,
        gpu: metadata?.run?.gpu || false,
        inject_node: metadata?.run?.inject_node || false,
      }
    } : {
      run: {type: 'data'},
      secret: metadata?.secret || false,
    };

    metadata = {
      ...metadata,
      ...metadataFiller
    }
    // console.log(metadata)
  };

</script>

{#if metadata}
  <select bind:value={metadata.run.type}>
    <option value="data">Data</option>
    <option value="code">Code</option>
  </select>

  {#if metadata.run.type !== 'data'}
    <input type="text" list="default_images" bind:value={metadata.run.base_image.name}/>
    <datalist id="default_images">
      <option value="python">Python</option>
      <option value="js">JavaScript</option>
      <option value="pytorch">Pytorch</option>
      <option value="pyselenium">Selenium-chrome (python)</option>
      <option value="pyvnc">Python with VNC</option>
    </datalist>

    <PkgDependencies bind:pkgDependencies={metadata.run.base_image.pkg_dependencies}/>
    <div><input type='number' bind:value={metadata.run.run_timeout} /> Run timeout </div>
    <div><input type='number' bind:value={metadata.run.idle_timeout} /> Idle timeout</div>
    <div><input type='number' min='0.05' step='0.05' max='8' bind:value={metadata.run.cpus} /> cpus</div>
    <div><input type='number' min='100' step='100' max='1600' bind:value={metadata.run.memory} /> memory</div>
    <div><input type='checkbox' bind:checked={metadata.run.gpu} /> GPU</div>
    <div><input type='checkbox' bind:checked={metadata.run.inject_node} /> inject_node</div>
  {:else}
    <div><input type='checkbox' bind:checked={metadata.secret}/> Secret</div>
  {/if}
    <div><input bind:value={metadata.editor} /> Editor </div>
    <div><input bind:value={metadata.display} /> Display </div>
{/if}
